/* Packages */
import React, { useEffect } from 'react';
import { NumericFormat } from 'react-number-format';
import Form from 'react-bootstrap/Form';
import { useFormContext } from 'react-hook-form';

/* Hooks */
import useValidation from 'conversie-flow-bundle/assets/js/components/flow/hooks/useValidation';

export default function ConversionFlowFieldMoney(props) {
    const { colClassName, field, path, id, updateValue } = props;
    const { type, label, required, disabled, placeholder = null, value, name } = field;

    const form = useFormContext();
    const {
        setValue = () => { },
        trigger = () => { },
    } = form || {};

    const { error } = useValidation({ path, ...field, ...form });

    useEffect(() => {
        setValue(path, value);
    }, [value]);

    return (
        <div className={`${colClassName}`}>
            <Form.Group controlId={id} className={`form-group--flow form-group--flow-field-${type} form-group--flow-${name}`}>
                {label && (
                    <Form.Label dangerouslySetInnerHTML={{ __html: label }} />
                )}
                <NumericFormat
                    id={id}
                    className={`form-control ${error ? 'is-error' : ''}`}
                    placeholder={label}
                    name={id}
                    {...{
                        required,
                        disabled,
                        placeholder,
                    }}
                    value={value || ''}
                    onValueChange={({ floatValue }, { source }) => {
                        if (typeof floatValue !== 'undefined' && source !== 'prop') {
                            updateValue(floatValue, () => {
                                trigger(path);
                            });
                        }
                    }}
                    decimalSeparator={','}
                    thousandSeparator={'.'}
                    prefix="€ "
                    suffix=""
                    fixedDecimalScale={true}
                    decimalScale={0}
                />
                {error && (
                    <Form.Control.Feedback type="invalid">
                        {error}
                    </Form.Control.Feedback>
                )}
            </Form.Group>
        </div>
    );
}
